import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=502fbfe0&scoped=true&"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=502fbfe0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502fbfe0",
  null
  
)

component.options.__file = "PageNotFound.vue"
export default component.exports